import React from 'react';
import { BackIcon, Box } from 'edenred-ui';

import { BackButtonProps } from '@epi-models/components/BackButton';

import history from '../../routes/history';

import './BackButton.scss';

export const BackButton = ({
  onClick = () => history.goBack()
}: BackButtonProps) => (
  <Box className="BackButton" display="inline" mr={1} onClick={onClick}>
    <BackIcon />
  </Box>
);
